export const KPI_COLORS = {
  CPIB: { bg: "#E6F4FF", iconBg: "#1677FF" },
  CBIB: { bg: "#FFF7E6", iconBg: "#FA8C16" },
  CPPIB: { bg: "#FFF1F0", iconBg: "#F5222D" },
  CPOIB: { bg: "#E6FFFB", iconBg: "#08979C" },
  CDOIB: { bg: "#F6FFED", iconBg: "#52C41A" },
  KAPAL: { bg: "#F0F5FF", iconBg: "#2F54EB" },
  MOHON: { bg: "#FFF7E6", iconBg: "#FAAD14" },
  TERBIT: { bg: "#FFF2E8", iconBg: "#FA541C" },
};
